export default __webpack_public_path__ + "static/media/Front-End-Illustration.b60f6601.svg";